export function validateFile(file, maxFileSize, showError, clearFileInput) {
  if (!file) {
    showError('No file selected');
    return false;
  }

  if (!file.name.toLowerCase().endsWith('.csv')) {
    showError('Please select a valid CSV file');
    return false;
  }

  if (file.size > maxFileSize) {
    showError(`File size exceeds the limit of 50MB. Please choose a smaller file.`);
    if (clearFileInput) {
      clearFileInput();
    }
    return false;
  }

  return true;
}

export function validateHeaders(headers, requiredHeaders) {
  const normalizedHeaders = headers.map(h => h.toLowerCase().trim());
  const missingHeaders = requiredHeaders.filter(
    header => !normalizedHeaders.includes(header.toLowerCase())
  );
  
  return missingHeaders.length > 0 
    ? `Missing required headers: ${missingHeaders.join(', ')}`
    : null;
}

export function showMappingValidationErrors(unmappedRequired, highlightUnmappedRequired) {
  const container = document.querySelector('.validation-errors');
  if (!container) return;
  
  container.innerHTML = '';
  container.style.display = 'block';
  
  const alert = document.createElement('div');
  alert.className = 'alert alert-danger d-flex align-items-center';
  alert.style.borderRadius = '6px';
  alert.style.backgroundColor = '#fef2f2';
  alert.style.borderColor = '#fecaca';
  alert.style.color = '#dc2626';
  
  const icon = document.createElement('span');
  icon.innerHTML = '⚠️';
  icon.style.marginRight = '8px';
  
  const message = document.createElement('span');
  message.innerHTML = `<strong>Required fields missing:</strong> Please map the following required headers: <strong>${unmappedRequired.join(', ')}</strong>`;
  
  alert.appendChild(icon);
  alert.appendChild(message);
  container.appendChild(alert);
  
  highlightUnmappedRequired(unmappedRequired);
  
  container.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

export function showMappingValidationError(message) {
  const container = document.querySelector('.validation-errors');
  if (!container) return;
  
  container.innerHTML = '';
  container.style.display = 'block';
  
  const alert = document.createElement('div');
  alert.className = 'alert alert-danger d-flex align-items-center';
  alert.style.borderRadius = '6px';
  alert.style.backgroundColor = '#fef2f2';
  alert.style.borderColor = '#fecaca';
  alert.style.color = '#dc2626';
  
  const icon = document.createElement('span');
  icon.innerHTML = '⚠️';
  icon.style.marginRight = '8px';
  
  const messageSpan = document.createElement('span');
  messageSpan.innerHTML = `<strong>Mapping Error:</strong> ${message}`;
  
  alert.appendChild(icon);
  alert.appendChild(messageSpan);
  container.appendChild(alert);
  
  container.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

export function highlightUnmappedRequired(unmappedRequired, mappedHeaders, requiredHeaders) {
  const selects = document.querySelectorAll('select[data-index]');
  
  selects.forEach(select => {
    const index = select.dataset.index;
    const mappedValue = mappedHeaders[index];
    const selectContainer = select.parentElement.parentElement;
    
    selectContainer.classList.remove('required-mapping-missing');
    
    const hasRequiredMapping = mappedValue && requiredHeaders.includes(mappedValue);
    const couldMapRequired = unmappedRequired.some(required => 
      Array.from(select.options).some(option => option.value === required)
    );
    
    if (!hasRequiredMapping && couldMapRequired) {
      selectContainer.classList.add('required-mapping-missing');
      
      selectContainer.style.backgroundColor = '#fef2f2';
      selectContainer.style.border = '2px solid #fecaca';
      selectContainer.style.borderRadius = '6px';
      selectContainer.style.padding = '8px';
      selectContainer.style.marginBottom = '8px';
    }
  });
}

export function clearValidationErrors() {
  const container = document.querySelector('.validation-errors');
  if (container) {
    container.innerHTML = '';
    container.style.display = 'none';
  }
  
  const mappingRows = document.querySelectorAll('.mapping-row');
  mappingRows.forEach(row => {
    row.classList.remove('required-mapping-missing');
    row.style.backgroundColor = '';
    row.style.border = '';
    row.style.borderRadius = '';
    row.style.padding = '';
    row.style.marginBottom = '';
  });
}
